import { Firebase } from "@/services/firebase";

// Get a Firestore instance
export const db = Firebase.firestore();
